import React from 'react';
import './Menu.css';

const Menu = () => {
    return (
        <div className='menucontainer'>All</div>
    )
}

export default Menu
